import { isWeixin } from '@/utils/userAgent'
import { LS_WECHAT_USER_INFO_KEY } from '@/configs/constants'
let wx = require('weixin-js-sdk')

export const initSet = pageInfo => {
    window.cw(
        'ajax',
        'jsconfig?url=' + encodeURIComponent(window.location.href.split(/[?#]/)[0]),
        function(code) {
            wx.config({
                debug: false,
                appId: code.appid,
                nonceStr: code.nonceStr,
                signature: code.signature,
                timestamp: code.timestamp,
                jsApiList: [
                    'updateAppMessageShareData',
                    'updateTimelineShareData'
                ]
            })
            setBaseInfo(pageInfo)
        }
    )
}
export function updateWxShareData(shareInfo) {
    if (!shareInfo.title) return
    if (shareInfo && shareInfo.title) {
        wx.ready(function() {
            //需在用户可能点击分享按钮前就先调用
            wx.updateAppMessageShareData({
                title: shareInfo.title, // 分享标题
                desc: shareInfo.description, // 分享描述
                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareInfo.image, // 分享图标
                success: function() {
                    // 设置成功
                }
            })
        })
        wx.ready(function() {
            //需在用户可能点击分享按钮前就先调用
            wx.updateTimelineShareData({
                title: shareInfo.title, // 分享标题
                desc: shareInfo.description, // 分享描述
                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareInfo.image, // 分享图标
                success: function() {
                    // 设置成功
                }
            })
        })
    }
}
export const setBaseInfo = pageInfo => {
    // 分享信息
    if (!pageInfo.title) return
    updateWxShareData(pageInfo.shareInfo)
    window.cw(
        'info',
        function(info) {
            localStorage.setItem(LS_WECHAT_USER_INFO_KEY, JSON.stringify(info))
            window.ca('set', 'appid', window.cw('get', 'appid'))
            window.ca('set', 'openid', info.openid)
            window.ca('set', 'nickname', info.nickname)
            window.ca('set', 'cms', pageInfo.cms || '')
            window.ca('set', 'tag', pageInfo.tagIds || '')
            window.ca('send', 'pageview', { title: pageInfo.title })
            let page = {
                title: pageInfo.title || window.document.title,
                cms: pageInfo.cms || '',
                tagIds: pageInfo.tagIds || '',
                path: window.location.href,
                uaId: window.ca('get', 'tid')
            }
            window.cw('action', 'pageview', page)
        },
        function() {
            if (isWeixin()) {
                window.cw('login')
            } else {
                window.ca('set', 'cms', pageInfo.cms || '')
                window.ca('set', 'tag', pageInfo.tagIds || '')
                window.ca('send', 'pageview', { title: pageInfo.title })
            }
        }
    )
}
